import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import { MdEventSeat } from "react-icons/md";
import { FaCalendarAlt } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { useDispatch } from 'react-redux';
import { setActiveLink } from '../redux/event/event.slice';
import axios from 'axios';



const useStyles = makeStyles({
  container: {
    padding: "20px"
  },
  heading: {
    marginBottom: "20px"
  },
  eventGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "20px"
  },
  eventCard: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    overflow: "hidden",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    backgroundColor: "#fff",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
    }
  },
  eventImage: {
    width: "100%",
    height: "150px",
    objectFit: "cover"
  },
  eventContent: {
    padding: "15px"
  },
  eventTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#333"
  },
  eventInfo: {
    margin: "8px 0",
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    color: "#666"
  },
  infoIcon: {
    marginRight: "8px",
    fontSize: "16px"
  },
  attendeesCount: {
    display: "inline-block",
    padding: "3px 10px",
    backgroundColor: "#e3f2fd",
    borderRadius: "15px",
    color: "#1976d2",
    fontWeight: "bold",
    marginTop: "10px"
  },
  viewDetailsBtn: {
    display: "block",
    width: "100%",
    padding: "10px",
    textAlign: "center",
    backgroundColor: "#0d6efd",
    color: "white",
    textDecoration: "none",
    borderRadius: "4px",
    marginTop: "15px",
    fontWeight: "bold",
    border: "none",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#0b5ed7"
    }
  }
});

// Mock data for demonstration - replace with API call

const EventList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Set the active link in the navigation
    dispatch(setActiveLink("Send Communication"));
    
    // In a real application, you would fetch events from your API
    // Replace this with your actual API call
    const fetchEvents = async () => {
      try {
        const response = await axios.get('https://api.thriftyx.com/admin/getPublishEvents');
        const formattedEvents = response.data.result.map(event => ({
          id: event._id,
          title: event.name,
          image: event.image,
          date: event.date,
          location: event.venue,
          attendeesCount: event.tickets.reduce((total, ticket) => total + ticket.sold, 0),
          type: event.type,
          city: event.city,
          venue_name: event.venue_name,
          start_time: event.start_time,
          end_time: event.end_time
        }));
        setEvents(formattedEvents);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch events. Please try again later.");
        setLoading(false);
        console.error("Error fetching events:", err);
      }
    };

    fetchEvents();
  }, [dispatch]);



  // Format date to a more readable format
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  if (loading) return <div className="container"><div className="text-center mt-5"><div className="spinner-border" role="status"></div><p>Loading events...</p></div></div>;
  if (error) return <div className="container"><div className="alert alert-danger mt-5" role="alert">{error}</div></div>;

  return (
    <div className={classes.container}>
      <h2 className={classes.heading}>
        <MdEventSeat style={{ marginRight: "10px" }} />
        Send Communication
      </h2>
      
      <div className={classes.eventGrid}>
        {events.map(event => (
          <div key={event.id} className={classes.eventCard}>
            <img src={event.image} alt={event.title} className={classes.eventImage} />
            <div className={classes.eventContent}>
              <h3 className={classes.eventTitle}>{event.title}</h3>
              
              <div className={classes.eventInfo}>
                <FaCalendarAlt className={classes.infoIcon} />
                {formatDate(event.date)}
              </div>
              
              <div className={classes.eventInfo}>
                <FaLocationDot className={classes.infoIcon} />
                {event.location}
              </div>
              
              <div className={classes.eventInfo}>
                <FaUsers className={classes.infoIcon} />
                <span className={classes.attendeesCount}>
                  {event.attendeesCount} Attendees
                </span>
              </div>
              
              <Link 
                to={`/event-attendees/${event.id}`} 
                className={classes.viewDetailsBtn}
                onClick={() => dispatch(setActiveLink("Event Attendees"))}
              >
                View Attendees
              </Link>
            </div>
          </div>
        ))}
      </div>
      
      {events.length === 0 && (
        <div className="text-center mt-5">
          <p>No events found. Create a new event to get started.</p>
        </div>
      )}
    </div>
  );
};

export default EventList;